import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('organizations');

actions.search = ({ filter }) => {
  const read = actions.read();
  const categories = encodeURIComponent(filter.categories.join(','));
  const fullText = encodeURIComponent(filter.fulltext);

  return {
    ...read,
    payload: {
      ...read.payload,
      // TODO: Do this more dynamically
      url: `${
        read.payload.url
      }?filter[category]=${categories}&filter[fulltext]=${fullText}`,
    },
  };
};
